import React,{Component} from 'react';
import './NabarClient.css';
import {NavLink , Link} from 'react-router-dom';
import logoblue from '../../../image/logoblue.png'

class NabarClient extends Component{

    render(){
        return(
<div className="  h-100 text-center   bg-white shadow">
<div className="navclient   text-center h-100 ">
    <ul className="navbar-nav  text-uppercase" >
          <li className="nav-item ">
                            <Link to="/"><img className="logo mt-3 mb-4" src={logoblue} alt="kayn" /></Link>
                        </li>
                        <li className="nav-item ">
                            <NavLink to="/NewOrder" className="iconnav "><div className="iconneworder mx-auto"></div><p className="fontsize15">New Order</p></NavLink>
                        </li>                            

                        <li className="nav-item ">
                            <NavLink to="/Orders" className="iconnav "><div className="iconorders  mx-auto">  </div><p className="fontsize15">Orders</p></NavLink>
                        </li>
                        <li className="nav-item ">
                            <NavLink to="/MyClients" className="iconnav "><div className="iconclient  mx-auto"></div><p className="fontsize15">MyClients</p></NavLink>
                        </li>
                        <li className="nav-item ">
                            <NavLink to="/ClientAdderss" className="iconnav "><div className="iconaddressbook   mx-auto"></div><p className="fontsize15">Adderss</p></NavLink>
                        </li>
                        <li className="nav-item ">
                            <NavLink to="/Wallet" className="iconnav "><div className="iconwallet  mx-auto"></div><p className="fontsize15">Wallet</p></NavLink>
                        </li>
                        
    </ul>
</div>




{/*  */}






</div>

        )
    }
}
export default NabarClient;